import React from "react";
import styled, { css } from "styled-components";

import img3 from "./img-3.jpg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar } from "@fortawesome/free-solid-svg-icons";

const Blog = () => {
  return (
    <BlogWrapper id="blog">
      <BlogSentence>Culpa perferendis excepturi.</BlogSentence>
      <BlogTitle>Our Blog</BlogTitle>
      <BlogGrid>
        <BlogImage image={img3}>
          <BlogDate>
            <BlogDateNumber>29</BlogDateNumber>
            <BlogDateMonth>JUN</BlogDateMonth>
          </BlogDate>
        </BlogImage>
        <BlogContent>
          <BCTitle>Lorem ipsum dolor.</BCTitle>
          <BCText>
            Lorem ipsum dolor sit amet, consectetur adipisicing elit. Nostrum
            vitae ducimus dolor sed numquam, assumenda non dolorem in facilis
            eius alias voluptates, fugit maiores aspernatur ad rem saepe
            molestiae consequuntur. adipisicing elit. Repellat nam placeat
            laboriosam dolorum aperiam fuga voluptate, quis ea vel ab sunt
            incidunt quasi, molestias atque deserunt voluptates quae voluptatum
            sit.
          </BCText>
          <BCProffency>Graphic Design</BCProffency>
          <BCData>
            <BCDataInfo>Admin</BCDataInfo>
            <BCDataInfo>|</BCDataInfo>
            <BCDataInfo>
              <FontAwesomeIcon icon={faStar} />
              213
            </BCDataInfo>
            <BCDataInfo>|</BCDataInfo>
            <BCDataInfo>
              <FontAwesomeIcon icon={faStar} />
              123
            </BCDataInfo>
          </BCData>
        </BlogContent>
      </BlogGrid>
    </BlogWrapper>
  );
};

export default Blog;

const BlogWrapper = styled.div`
  width: 100vw;
  height: 57.5vh;
  background-color: #e1f1f5;
  overflow-y: hidden;

  @media screen and (orientation : portrait) {
    height : 80vh;
  }
`;

const BlogSentence = styled.h1`
  margin: 0;
  color: gray;
  font-size: 0.9vw;
  font-weight: 400;
  margin-left: 15vw;
  padding-top: 2vw;

  @media screen and (orientation: portrait) {
    max-width: 100vw;
    font-size: 1.75vh;
    margin-left: 5vw;
  }
`;
const BlogTitle = styled.h1`
  margin: 0;
  font-size: 2vw;
  color: black;
  font-weight: 500;
  margin-left: 15vw;

  @media screen and (orientation: portrait) {
    max-width: 100vw;
    font-size: 4.25vh;
    margin-left: 5vw;
  }
`;

const BlogGrid = styled.div`
  width: 70vw;
  height: 35vh;
  margin-left: 15vw;
  margin-top: 4vh;

  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(1, 1fr);
  justify-items: center;
  align-items: center;

  @media screen and (orientation : portrait) {
    width : 95vw;
    height :83vh;
    margin-left : 2.5vw;

    display : grid;
    grid-template-columns : repeat(1,1fr);
    grid-template-rows : repeat(2,1fr);
  }
`;

const BlogImage = styled.div`
  width: 20vw;
  height: 30vh;

  background-size: cover;
  background-image: url(${(props) => props.image});

  @media screen and (orientation : portrait) {
    width : 90vw;
  }
`;

const BlogDate = styled.div`
  display: flex;
  flex-direction: column;
  width: 3vw;
  height: 4.7vw;
  background-color: red;
  margin-left: 1vw;
  margin-top: 1vw;

  @media screen and (orientation : portrait) {
    width : 6vh;
    height : 8.2vh;
  }
`;

const BlogDateNumber = styled.h1`
  margin: 0;
  text-align: center;
  color: white;
  width: 3vw;
  height: 2.7vw;
  background-color: #f07069;
  padding-top: 0.6vw;
  font-size: 1.6vw;

  @media screen and (orientation : portrait) {
    width : 6vh;
    height : 5.4vh;
    font-size : 3.4vh;
  }
`;

const BlogDateMonth = styled.h1`
  margin: 0;
  text-align: center;
  color: white;
  background-color: #de554e;
  width: 3vw;
  height: 1.4vw;
  font-size: 1vw;
  @media screen and (orientation: portrait) {
    width : 6vh;
    height : 2.8vh;
    font-size : 1.85vh;
  }
`;

const BlogContent = styled.div`
  width: 50vw;
  height: 31vh;

  @media screen and (orientation: portrait) {
    width : 90vw;
    height : 50vh;
  }
`;

const BCTitle = styled.h1`
  font-size: 1.5vw;
  font-weight: 600;
  color: black;
  margin: 0;
  padding-left: 2vw;

  @media screen and (orientation: portrait) {
    font-size : 3vh;
  }
`;

const BCText = styled.h2`
  font-size: 1.15vw;
  color: grey;
  opacity: 0.8;
  font-weight: 300;
  max-width: 50vw;
  text-align: left;
  padding-left: 2vw;

  @media screen and (orientation: portrait) {
    font-size: 1.7vh;
    max-width : 90vw;
  }
`;

const BCProffency = styled.button`
  margin-left: 2vw;
  color: white;
  background-color: #3ca7ba;
  border: none;
  border-radius: 0.5vw;
  font-size: 0.8vw;

  @media screen and (orientation: portrait) {
    font-size: 1.6vh;
  }
`;

const BCData = styled.div`
  width: 14vw;
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  grid-template-rows: repeat(1, 1fr);
  justify-items: center;
  align-items: center;
  margin-left: 2vw;

  @media screen and (orientation: portrait) {
    width : 25vh;
  }
`;

const BCDataInfo = styled.h1`
  font-size: 0.85vw;
  color: gray;
  text-align: left;

  position: relative;
  display: flex;

  @media screen and (orientation: portrait) {
    font-size: 1.6vh;
  }
`;
